import React, {useEffect, useState} from "react";
import {Button, Layout} from 'antd';
import {useHistory} from "react-router-dom";
import {LogoPart} from "../default/LogoPart";
import {FooterSidebar} from "../default/FooterSiderbar";
import {TableMetadata} from "../../../views/apps/project/backups/chats/detail/TableMetadata";
import {TablesSelect} from "../../../views/apps/project/backups/chats/detail/TablesSelect";

const {Sider, Content} = Layout;


export const ChatsSidebar = ({user, chats, chatId, metadata, tables, selectedTable, onSelect}) => {

    let history = useHistory();

    const [conversations, setConversations] = useState(undefined);
    const [selectedKey, setSelectedKey] = useState(undefined);

    useEffect(() => {

        if (conversations === undefined) {
            setConversations(chats);
        }

    }, [chats]);

    useEffect(() => {
        if (conversations !== undefined && chatId !== undefined) {
            setSelectedKey(chatId);
        }
    }, [chatId, conversations]);

    const handleSelectConversation = (key) => {
        setSelectedKey(key);
        history.push(`/chats/${key}`);
    }

    const headerStyle = {
        height: 64,
        background: '#FFFFFF',
    };
    const contentStyle = {
        overflow: 'auto',
        background: '#FFFFFF',
        height: '100vh',
        padding: '20px',
    };
    const layoutStyle = {
        overflow: 'hidden',
        minHeight: '100vh',
        height: '100vh',
        background: '#FFFFFF',
    };

    return <Sider width={400}
                  className="sider"
                  theme={"light"}
                  collapsed={false}
    >
        <Layout style={layoutStyle}>
            <Content style={headerStyle}>
                {user && <LogoPart user={user}/>}</Content>
            <Content style={contentStyle}>
                <TablesSelect tables={tables} selectedTable={selectedTable} onSelect={onSelect}/>
                <TableMetadata metadata={metadata}/>
            </Content>
            <Content>{user && <FooterSidebar user={user}/>}</Content>
        </Layout>
    </Sider>

}